import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import PagesContainer from "../../components/UI/PagesContainer";
import { usePage } from "../../hooks/usePage";
import Actions from "./Actions";

const NewScheduleHome = () => {
  const { t } = useTranslation();
  const { pageTitle } = usePage();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <PagesContainer
      title={pageTitle || t("page.schedules.home.schedules")}
      sx={mobile ? { height: "calc(100% - 5rem)" } : undefined}
    >
      <Stack gap={3} mr={1}>
        <Actions />
      </Stack>
    </PagesContainer>
  );
};

export default NewScheduleHome;
